module.exports = __webpack_public_path__ + "media/images/sports_icons/021-sailing-7b4dbb06f302cee20aed8c5ad06c15dd.png";